module.exports = __webpack_public_path__ + "img/poker-h03.e1830508.svg";